import { Component, OnInit, AfterViewInit, Inject, Output, EventEmitter } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../core/services/auth.service';
import { Request } from '../core/models/request.model';
import { Howl, Howler } from 'howler';
import * as moment from 'moment';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  menu: any = [];

  routerUrl: string;

  sound: Howler = new Howl({
    src: ['assets/sounds/alarm.wav'],
    volume: 1,
  });

  constructor(private router: Router, private db: DbService, private auth: AuthService) {
    router.events.forEach(event => {
      if (event instanceof NavigationEnd) {
        this.routerUrl = event.url;
      }
    });
  }

  async ngOnInit() {
    const uid = await this.auth.uid();
    let today = moment().hour(0).minute(0).toISOString();
    if (uid === 'gnns7b0xoBaqrO68de9GWLmaJfw2') {
      this.menu = [
        {
          label: '대시보드',
          icon: 'bx-home',
          link: '/dashboard',
        },
        {
          label: '오늘 실시간 탁송의뢰',
          icon: 'bx-car',
          link: '/today-request',
          badge: false,
        },
        {
          label: '회원 관리',
          icon: 'bx-group',
          subItems: [
            {
              label: '일반 회원 관리',
              link: '/user-list',
            },
            {
              label: '업체 관리',
              link: '/company-list',
            },
          ],
        },
        {
          label: '견적 문의 관리',
          icon: 'bx-notepad',
          badge: false,
          subItems: [
            {
              label: '견적문의 및 답변',
              link: '/estimate-inquiry',
            },
          ],
        },
        {
          label: '차량 정보 관리',
          icon: 'bx-task',
          link: '/car-info-list',
          badge: false,
        },
        {
          label: '정비내역 및 결제 관리',
          icon: 'bx-notepad',
          badge: false,
          subItems: [
            {
              label: '정비내역 및 수익금',
              link: '/service-list',
            },
          ],
        },
        {
          label: '멤버십 관리',
          icon: 'bx-id-card',
          link: '/membership-list',
          badge: false,
        },
        {
          label: '신고 관리',
          icon: 'bx-error',
          badge: false,
          subItems: [
            {
              label: '업체 신고 관리',
              link: '/report-shop',
            },
            {
              label: '후기 신고 관리',
              link: '/report-review',
            },
          ],
        },
        {
          label: '서비스/정보관리',
          icon: 'bx-note',
          subItems: [
            {
              label: '공지사항',
              link: '/notice',
            },
            {
              label: '자주 묻는 질문',
              link: '/faq',
            },
            {
              label: '개인정보 / 이용약관',
              link: '/terms',
            },
          ],
        },
        {
          label: '모니카 정보 관리',
          icon: 'bx-info-circle',
          link: '/monicar-info',
          badge: false,
        },
      ];

      combineLatest(
        this.db.collection$(`requests`),
        this.db.collection$(`reports`, ref => ref.where('adminCheck', '==', false).where('deleteSwitch', '==', false)),
        this.db.collection$(`memberships`, ref => ref.where('adminCheck', '==', false))
      )
        .pipe(
          map(([requests, reports, memberships]) => {
            let repair: Request[] = JSON.parse(JSON.stringify(requests)).filter(
              request => request.status !== 'request' && request.status !== 'return' && !request.repairCheck
            );
            let request: Request[] = JSON.parse(JSON.stringify(requests)).filter(
              request => !request.requestCheck && ((request.status === 'request' && !request.cancelSwitch) || request.status === 'return')
            );
            let deliverys: Request[] = JSON.parse(JSON.stringify(requests)).filter(
              request =>
                request.dateCreated > today &&
                (request.status === 'return' || request.status === 'askRepair' || request.status === 'endRepair') &&
                !request.adminCheck
            );

            return {
              delivary: deliverys.length > 0,
              request: request.length > 0,
              repair: repair.length > 0,
              report: reports.length > 0,
              membership: memberships.length > 0,
            };
          })
        )
        .subscribe(allBadge => {
          this.menu[1].badge = allBadge.delivary;
          this.menu[3].badge = allBadge.request;
          this.menu[5].badge = allBadge.repair;
          this.menu[6].badge = allBadge.membership;
          this.menu[7].badge = allBadge.report;
        });
    } else {
      this.menu = [
        {
          label: '오늘 실시간 탁송의뢰',
          icon: 'bx-car',
          link: '/today-request',
          badge: false,
        },
      ];

      this.db
        .collection$(`requests`, ref =>
          ref.where('status', 'in', ['return', 'askRepair', 'endRepair']).where('dateCreated', '>', today).where('adminCheck', '==', false)
        )
        .subscribe((requests: Request[]) => {
          const badge = requests.length > 0;

          this.menu[0].badge = badge;
          if (badge) {
            setTimeout(() => {
              this.sound.play();
            }, 500);
          }

          if (this.router.url !== '/today-request') {
            this.router.navigateByUrl('/today-request');
          }
        });
    }

    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.auth.logoutUser().then(() => {
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach(ele => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(`.atag${mi}${index}`);
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }
}
